import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import {
  RenderEnvironmentContext,
  ReploElementContext,
  useRuntimeContext,
} from "../../../shared/runtime-context";
import { isFeatureSupported } from "../../../shared/utils/supportedFeatures";
import RenderComponentPlaceholder from "../RenderComponentPlaceholder";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const ShopifySection: React.FC<RenderComponentProps> = ({
  component,
  componentAttributes,
}) => {
  const sectionName = component.props._shopifySectionName;
  const { elementType } = useRuntimeContext(ReploElementContext);
  const { isEditorApp } = useRuntimeContext(RenderEnvironmentContext);

  if (isEditorApp) {
    return (
      <div {...componentAttributes}>
        <RenderComponentPlaceholder
          type="shopifySection"
          title="Shopify Section"
          sectionName={sectionName}
        />
      </div>
    );
  }
  return (
    <SharedShopifyLiquid
      liquidSource={sectionName ? `{% section '${sectionName}' %}` : null}
      componentId={component.id}
      componentAttributes={componentAttributes}
      isLiquidSupported={isFeatureSupported(elementType, "shopifyLiquid")}
    />
  );
};

export default ShopifySection;
